import React from 'react';
import { Empty } from 'antd'
import useImg from '../hooks/useImg';
import './searchList.less'

const male = '//img.alicdn.com/imgextra/i1/O1CN01aPROLw1CsKYt1GvW6_!!6000000000136-2-tps-28-28.png'
const female = '//img.alicdn.com/imgextra/i3/O1CN01BU5dmU1ayKWiaL3ZA_!!6000000003398-2-tps-28-28.png'

export interface SearchListProps {
  list: any[]
}
export interface SearchItemProps {
  item: any
}

const SearchItem = (props: SearchItemProps) => {
  const { item } = props
  const {
    picUrl,
    onError
  } = useImg({
    imgSrc: item.picUrl,
    defaultSrc: '//img.alicdn.com/imgextra/i2/O1CN010P2s3r1rfs2DwCsQp_!!6000000005659-2-tps-274-274.png'
  })
  let href = `/star-source/brand/detail?cid=${item.cid}`
  let tArea = <div className="text-area">
    <div className="text-normal desc">{item.description || ''}</div>
  </div>
  if (item.type === '艺人') {
    href = `/star-source/artist/detail?cid=${item.cid}`
    let gender = <></>
    if (item.gender === '男') {
      gender = <div className="gender-icon"><img className="img" src={male} /></div>
    } else if (item.gender === '女') {
      gender = <div className="gender-icon"><img className="img" src={female} /></div>
    }
    tArea = <div className="text-area">
      {gender}
      <div className="text-normal">{item.profession || ''}</div>
      <div className="text-normal">{item.birthday ? `出生于${item.birthday}` : ''}</div>
      <div className="text-grey">{item.endorsement || ''}</div>
    </div>
  }
  return <a className="search-item" href={href} target="_blank">
    <img className="head-img" src={picUrl} onError={onError} />
    <div className="item-body">
      <div className="title-area">
        <div className="item-title">{item.name}</div>
        <div className="item-type">{item.type}</div>
      </div>
      {tArea}
    </div>
  </a>
}

const SearchList = (props: SearchListProps) => {
  const { list } = props;

  return <div className="search-content">
    {
      list.length ? list.map((item) => {
        return <SearchItem key={item.cid} item={item} />
      }) : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
    }
  </div>
};

export default React.memo(SearchList);

